<template>
  <BaseButton primary @click="createAccProduct"> New Product </BaseButton>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    createAccProduct() {
      this.$modal.show({
        component: () => import('@/components/AccountAccProducts/AccProductCreateModal.vue'),
        props: {
          accountId: this.accountId,
        },
        on: {
          created: (accProductId) => {
            this.$emit('created', accProductId);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
